var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05473 3.79796L0.129939 0.74817C0.0897199 0.706067 0.0580085 0.659045 0.0348051 0.607102C0.0116017 0.555321 0 0.499748 0 0.440385C0 0.32182 0.0384403 0.21874 0.115321 0.131147C0.192201 0.0437154 0.293523 0 0.419285 0H6.58071C6.70648 0 6.8078 0.0441993 6.88468 0.132599C6.96156 0.220837 7 0.323836 7 0.441595C7 0.471115 6.95661 0.573306 6.86983 0.74817L3.94527 3.79796C3.87814 3.86813 3.80868 3.91934 3.73691 3.95161C3.66513 3.98387 3.58616 4 3.5 4C3.41384 4 3.33487 3.98387 3.26309 3.95161C3.19132 3.91934 3.12186 3.86813 3.05473 3.79796Z",
    fill: "#595D72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescActive);
export default __webpack_public_path__ + "static/media/desc_active.928303f4af51eb47a6a7372b77be79a7.svg";
export { ForwardRef as ReactComponent };